// src/components/Footer/Footer.jsx
import React from "react";
import "./Footer.css";
import logo from "../../assets/images/logo.png";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        {/* Colonne 1 : Logo + présentation */}
          {/* <div className="logo">NEXUS SOLUTIONS</div> */}
          <img src={logo} alt="Logo de NEXUS SOLUTIONS" className="logo-img" />
        <div className="footer-col">
          <h4>À propos de nous</h4>
          <p className="footer-about">
            Nexus Solutions (NXS) est une entreprise innovante spécialisée dans le
            développement de solutions digitales sur mesure. Notre mission est
            d’accompagner les entreprises dans leur transformation numérique grâce à
            des outils performants, modernes et adaptés à leurs besoins.
          </p>
        </div>

        {/* Colonne 2 : Solutions */}
        <div className="footer-col center">
          <h4>Nos solutions</h4>
          <ul>
            <li>Développement d'applications</li>
            <li>Intégration de systèmes</li>
            <li>Solutions web et mobiles</li>
          </ul>
        </div>

        {/* Colonne 3 : Contacts */}
        <div className="footer-col">
          <h4>Contacts</h4>
          <p>Adresse : Cocody, Angré, Cité des Racines</p>
          <p>Email : hassanesoumahoro6@gmail.com</p>
          <p>Téléphone : 07 67 15 67 49</p>
        </div>
      </div>

      {/* Bas du footer */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} NEXUS SOLUTIONS — Tous droits réservés
      </div>
    </footer>
  );
}
